
export const checkHasExchangeableCouponsWithBook = (coupons, bookId) => {
  const targetCoupons = coupons.filter((coupon) => coupon.book_id == bookId);
  return targetCoupons.some((coupon) => isExchangeableCoupon(coupon));
}

const isExchangeableCoupon = (coupon) => {
  // 特付きFPのみ対象
  return coupon.is_exchangeable && coupon.type == "exchange";
}